import React, { useState, useEffect, useCallback } from 'react';
import './Board.scss';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import common from '../../common';
import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Board = () => {
    const member_idx = useSelector((state) => state.user.loginInfo || null);

    const { pToast, useAlert, useModal, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const cateIdx = queryParams.get('cateIdx');
    const boardType = queryParams.get('boardType');

    let title = '';
    if(cateIdx === '3'){
        title = '홍보게시판';
    }else if(cateIdx === '8'){
        title = '질문게시판';
    }else if(cateIdx === '9'){
        title = '자유게시판';
    }else if(cateIdx === '13'){
        title = 'YEHStudy';
    }else if(cateIdx === '14'){
        title = 'YEHS 소모임';
    }

    let targetIdx = '';
    let AlertTitle = '';
    let apiUrl = `${API_BASE_URL}/yehs_document/in/user_document_write`; // 기본 URL

    if (boardType === 'edit') {
        targetIdx = queryParams.get('targetIdx');
        AlertTitle = '수정';
        apiUrl = `${API_BASE_URL}/yehs_document/in/user_document_edit`; // 수정일 경우 URL 변경
    } else if (boardType === 'new') {
        AlertTitle = '등록';
    }




    const [headCateOptions, setHeadCateOptions] = useState([]);
    // headCate 가져오기 (cateIdx가 3 일때만)
    useEffect(() => {
        // cateIdx가 3번일 때만 fetchOptions를 실행
        if (cateIdx === '3') {
            const fetchOptions = async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_document_category_head_table`, { document_category_idx: cateIdx }, {
                        withCredentials: true
                    });
                    if (response.data.result === 't') {
                        const headCate = response.data.data.map(option => ({
                            value: option.idx,
                            label: option.name
                        }));
                        setHeadCateOptions(headCate);

                        setFormData((prevFormData) => ({
                            ...prevFormData,
                            headCate: headCate[0] || null,
                        }));

                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('Error fetching options:', error);
                    pAlert('데이터 가져오기에 실패했습니다. 다시 시도해주세요.');
                } finally {
                    pLoadingOff();
                }
            };
    
            fetchOptions();
        }
    }, [cateIdx]); // cateIdx가 변경될 때 useEffect가 실행됩니다.

    const [formData, setFormData] = useState({
        cateIdx: parseInt(cateIdx), //공통
        title: '', //공통
        contents: '', //공통
        file: [], //공통
        fileDel: [], //공통
        headCate: null,
    });


    useEffect(() => {
        if (boardType === 'edit') {
            const fetchData = async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_detail`, {idx : parseInt(targetIdx) , type : 'do'},
                        {
                            withCredentials: true,
                        }
                    );
                    if (response.data.result === 't') {
                        const data = response.data.data;

                        
                        // headCateOptions가 설정된 후에 선택된 값이 제대로 반영되도록 함
                        setHeadCateOptions(prevOptions => {
                            const selectedHeadCate = prevOptions.find(option => option.label === data.headCate) || null;
                            
                            setFormData({
                                cateIdx: parseInt(cateIdx), 
                                title: data.title || '',      
                                contents: data.contents || '',
                                file: data.file.map(file => ({
                                    idx: file.idx,
                                    name: file.name,
                                    serverName: file.serverName,
                                    isExisting: true // 기존 파일임을 표시
                                })), 
                                headCate: selectedHeadCate, // 선택된 값 설정
                                fileDel: [],
                            });

                            return prevOptions; // 반환값 필요
                        });
                        // 이 부분
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('등록 실패:', error);
                    pAlert('등록에 실패했습니다. 다시 시도해 주세요.');
                } finally {
                    pLoadingOff();
                }
            };

            fetchData();
        }
        // boardType이 new일 경우에는 formData가 빈값으로 초기화 되어있으므로 추가 작업은 필요하지 않음
    }, [boardType, cateIdx]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };




    
    const [inputKey, setInputKey] = useState(Date.now());



	const handleFileChange = (event) => {
        event.preventDefault();
        const files = Array.from(event.target.files);
        const newFiles = files.map((file) => ({
            name: file.name,
            file: file,
            isLocal: true, // 로컬 파일 표시
        }));

        setFormData(prevFormData => ({
            ...prevFormData,
            file: [...(prevFormData.file || []), ...newFiles]  // 기존 파일 리스트에 새로운 파일을 추가
        }));

        // 파일 입력 요소 초기화
        setInputKey(Date.now());
    };

	// 파일 선택 상태 업데이트
    const handleFileSelect = (selectedFile) => {
        setFormData((prevFormData) => {
            const updatedFiles = prevFormData.file.map(file =>
                file.name === selectedFile.name
                    ? { ...file, isSelected: !file.isSelected }
                    : file
            );
            return {
                ...prevFormData,
                file: updatedFiles
            };
        });
    };

	// 선택된 파일 삭제
    const handleFileDeleteSelected = (e) => {
        e.preventDefault();
        setFormData((prevFormData) => {
            const updatedFiles = [];
            const deletedFiles = [];
    
            // 삭제된 파일을 추출하고 남은 파일을 업데이트
            prevFormData.file.forEach(file => {
                if (!file.isSelected) {
                    updatedFiles.push(file);
                } else {
                    if (file.isExisting) {
                        // 기존 파일이면 fileDel에 파일 전체 객체를 추가
                        deletedFiles.push(file); // 전체 파일 객체를 추가
                    }
                }
            });
    
            return {
                ...prevFormData,
                file: updatedFiles,
                fileDel: [...prevFormData.fileDel, ...deletedFiles] // 삭제된 파일 객체들을 fileDel에 추가
            };
        });
    };



    


	const handleSave = async (e) => {
        e.preventDefault();

        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            pAlert('로그인 상태에서 '+AlertTitle+'하실 수 있습니다.');
            return false;
        }

        // FormData 객체 생성
        let formDataToSend = new FormData();

        // formData 객체의 각 필드를 FormData 객체에 추가
        for (const key in formData) {
            if (key === 'file') {
                formData[key].forEach((fileObj) => {
                    if (fileObj.isExisting) {
                        // 기존 파일은 서버의 파일 경로 또는 파일 ID를 전송 (필요시)
                    } else {
                        // 새로 추가된 파일은 File 객체로 전송
                        formDataToSend.append('file', fileObj.file);
                    }
                });
            } else if (key === 'fileDel') {
                if (Array.isArray(formData[key]) && formData[key].length > 0) {
                    // fileDel 배열을 JSON 문자열로 변환하여 전송
                    formDataToSend.append('fileDel', JSON.stringify(formData[key]));
                }
            } else if (key === 'headCate') {
                if (formData[key] && formData[key].value) {
                    // headCate 값이 있을 때만 추가
                    formDataToSend.append('headCate', formData[key].value);
                }
            } else {
                // 다른 필드들은 그대로 추가
                formDataToSend.append(key, formData[key]);
            }
        }

        if(boardType === 'edit'){
            formDataToSend.append('targetIdx', targetIdx);
        }

        // for (let [key, value] of formDataToSend.entries()) {
        //     console.log(`${key}: ${value instanceof File ? value.name : value}`);
        // }

        pConfirm(
            '게시글 등록',
            <>
                <div>{title}에 {AlertTitle}을 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(apiUrl, formDataToSend, // 변경된 URL 사용
                        {
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    if (response.data.result === 't') {
                        let alertMessage = '게시물 ' + AlertTitle + '이 완료되었습니다.';

                        // cateIdx가 '3'일 때만 추가 메시지를 포함합니다.
                        if (cateIdx === '3') {
                            alertMessage += ' 관리자 승인 후 최종게시 됩니다.';
                        }

                        pAlert(alertMessage);

                        setTimeout(() => {
                            window.history.back();
                        }, 1500);
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('등록 실패:', error);
                    pAlert('등록에 실패했습니다. 다시 시도해 주세요.');
                } finally {
                    pLoadingOff();
                }
            }
        );
    };





























	const handleBack = async (e) => {
		window.history.back();
	};





    return (
        <>
            <AlertComponent />
            <ConfirmComponent />
            <div className="p_board_wrap">
                <div className="p_board_title_box">
                    <span>{title} 등록</span>
                </div>
                <div className="p_board_detail_wrap">
                    <div className="p_board_textarea_wrap">
                        <div className="input_wrap">
                            <div className="input_box">
                                {cateIdx === '3' && (
                                        <select 
                                        className='head_cate_select'
                                        value={formData.headCate?.value || ""}
                                        onChange={(e) => setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            headCate: headCateOptions.find(option => option.value === parseInt(e.target.value))
                                        }))}
                                    >
                                        {headCateOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                                <div className="input_tit_box">
                                    <input
                                        type="text"
                                        placeholder="제목을 입력하세요"
                                        className="p_input"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="p_board_textarea_box">
                            <textarea
                                name="contents"
                                value={formData.contents}
                                onChange={handleInputChange}
                            ></textarea>
                        </div>
                        <div className="input_file_box">
                            <div className="input_file_txt_box flex_between">
                                <span className='f_bigger f_500'>첨부파일</span>
                                <div className="input_file_btn_box display_flex">
                                    <button
                                        className="input_file_button_del"
                                        onClick={handleFileDeleteSelected}
                                    >
                                        선택 삭제
                                    </button>
                                    <label className="input_file_button" htmlFor="input-file">
                                        파일 업로드
                                    </label>
                                    <input
                                        key={inputKey}
                                        type="file"
                                        id="input-file"
                                        multiple
                                        onChange={handleFileChange}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </div>
                            <div className="file_list">
                                {formData?.file.length > 0 && formData?.file.map((fileObj, index) => (
                                    <div key={index}>
                                        <label className="p_chkbox">
                                            <input
                                                type="checkbox"
                                                id={`file-${index}`}
                                                checked={fileObj.isSelected || false}
                                                onChange={() => handleFileSelect(fileObj)}
                                            />
                                            <span>{fileObj.name}</span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="edit_btn_wrap">
                            <div className="edit_btn_box_nondata">
                                <button className='edit_cancel_btn' onClick={handleBack}>취소</button>
                                {boardType === 'new' ? (
                                    <>
                                        <button className='edit_regist_btn' onClick={handleSave}>등록</button>
                                    </>
                                ) : boardType === 'edit' ? (
                                    <>
                                        <button className='edit_regist_btn' onClick={handleSave}>수정</button>
                                    </>
                                ):(
                                    <></>
                                )}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        
    );
};

export default Board;
